<div class="main">
  <spb-header></spb-header>
  <router-outlet></router-outlet>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [copyrightYears]="copyrightYears"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
  ></spb-footer>
</div>